import { RightArrowIcon } from '@sketchnote/icons';
import React from 'react';

import Dialog from '../dialogs';
import { DialogPosition, DialogProps } from '../dialogs/types';

export type TooltipPosition = DialogPosition;

export interface TooltipProps extends DialogProps {
  children: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  title: string;
}

export const Tooltip = ({
  children,
  title,
  position = 'right top',
  on = 'hover',
  ...otherProps
}: TooltipProps): JSX.Element => {
  return (
    <Dialog trigger={children} position={position} className="tooltip" on={on} {...otherProps}>
      <span> {title}</span>
    </Dialog>
  );
};

export interface TooltipTutorialProps {
  children: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  title: string;
  body?: string;
  onNext?: () => void;
  onSkip?: () => void;
}

export const TooltipTutorial = ({
  children,
  title,
  body,
  onNext,
  onSkip,
}: TooltipTutorialProps): JSX.Element => {
  return (
    <span>
      <Dialog
        trigger={children}
        position="right top"
        // on={["hover", "focus"]}
        className="tooltip-turorial"
        overlayClassName="bg-transparent"
      >
        <div>
          <h2 className="font-medium mb-8 text-white">{title}</h2>
          <p className="text-sm mb-18">{body}</p>
          <div className="flex justify-between">
            <span className="font-medium text-sm flex items-center" role="button">
              <span className="mr-13" onClick={onNext}>
                Next
              </span>
              <RightArrowIcon />
            </span>
            <span role="button" className="font-medium text-sm opacity-50" onClick={onSkip}>
              Skip this messages
            </span>
          </div>
        </div>
      </Dialog>
    </span>
  );
};
